var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.47208 13.3569C2.41223 15.569 4.19265 17.3171 6.42168 18.2166C8.6507 19.116 11.1457 19.0932 13.3579 18.153C15.5701 17.2129 17.3182 15.4324 18.2176 13.2034C19.1171 10.9744 19.0942 8.47936 18.1541 6.26719C17.2139 4.05502 15.4335 2.30693 13.2045 1.40748C10.9754 0.508022 8.4804 0.530884 6.26824 1.47103C4.05607 2.41118 2.30798 4.19161 1.40852 6.42063C0.50907 8.64965 0.531933 11.1447 1.47208 13.3569Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2209 16.22L23.2499 23.25",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.138cd6190872486c42456747eec35a33.svg";
export { ForwardRef as ReactComponent };